import { connect } from "react-redux"
import { compose } from "redux"
import StatisticsPageComparativeReports from "../components/statistics-page-comparative-reports"
import { getVariables } from "../utilities/route"
import { withData } from "../decorators/with-data"
import gql from "graphql-tag"
import { withTranslations } from "../decorators/with-translations"
import { setSubmitError, setCrSection } from '../actions/survey'
import { QUESTIONNAIRE_FRAGMENT } from "../graphql/fragments"
import { withImprovementProjectData } from './withImprovementProjectData'

const query = gql`
  query FinishPage(
    $languageCode: String
  ) {
    questionnaire(languageCode: $languageCode) {
      ...QuestionnaireFragment
    }
  }
  ${QUESTIONNAIRE_FRAGMENT}
`;

const mapStateToProps = ({ survey: { submitError, crSection } }) => {
  return {
    submitError,
    crSection
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    onSubmitError: (error) => {
      dispatch(setSubmitError(error));
    },
    onSetCrSection: (crSection) => {
      dispatch(setCrSection(crSection));
    },
  };
};

export default compose(
  withTranslations,
  withData(query, {
    options: (props) => {
      return {
        ...getVariables(props),
        fetchPolicy: "network-only",
      };
    },
  }),
  connect(mapStateToProps, mapDispatchToProps),
  withImprovementProjectData,
)(StatisticsPageComparativeReports)



// WEBPACK FOOTER //
// ./src/containers/statistics-page-comparative-reports.js